import { Box, Button, Container, IconButton, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import "./styles/index.scss";
import TextEditor from "./components/editor";
import NewBlock from "./components/newBLock";
import ToggleVisibilityButton from "./components/toggleVisibility";
import {ModalConfirm} from "./components/modalConfirm";
import { toast } from "react-toastify";
import CloseIcon from '@mui/icons-material/Close';

export enum BlockType {
    TEXT = 'text',
    IMAGE = 'image',
}

export interface Block{
    type: BlockType;
    content: string;
    imageFile: File | undefined;
    imageUrl: string | undefined;
}
const Blog = () => {

    const [isVisibledPublic, setIsVisibledPublic] = useState<boolean>(false);
    
    const [title, setTitle] = useState<string>();
    
    const [preview, setPreview] = useState<string>();

    const [list, setList] = useState<Block[]>([]);


    const handleNewBlock = (type: BlockType, file: File, url: string) => {
        setList(prevState => {
            const newItem: Block = {
                type,
                content: "",
                imageFile: file,
                imageUrl: url
            };
    
            return [...prevState, newItem];
        });
    };
    
    const handleChangeContent = (newContent: string, i: number) => {
        setList(prevState => {
            const newState = [...prevState];
            
            const updatedItem = { ...newState[i], content: newContent };
            newState[i] = updatedItem;
    
            return newState; 
        });
    };
    
    const [showConfirm, setShowConfirm] = useState<boolean>(false);

    const handleClick = () => {
        if(title && title.length > 0 && list.length > 0){
            setShowConfirm(true);
            toast.warning("Verifica e escolha tags.");
        }else{
            toast.error("Faltando título ou parágrafos!");
        }
    }
    const handleRemove = (index: number) => {
        setList(prevState => {
            const newState = [...prevState];
            newState.splice(index, 1);
            return newState; 
        });
    }

    if(isVisibledPublic) return (
    <Container>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center"}}>
            <Typography variant="h5" sx={{ m: "0 auto"}}>{title}</Typography>
            <ToggleVisibilityButton isVisibledPublic={isVisibledPublic} changeToggle={setIsVisibledPublic}/>
        </Box>
        <Box component="ul" sx={{ p: 0 }}>
            {
                list.map((block, index) => {
                    if(block.type === BlockType.IMAGE)
                        return <img key={index}  style={{ width: "100%" }} src={block.imageUrl}/>
                    else
                    return (
                        <Box key={index} dangerouslySetInnerHTML={{ __html: block.content }} >
                        </Box>
                    )
                })
            }
        </Box>
    </Container>)
    else
    return <Container>
        <ModalConfirm 
            open={showConfirm} 
            setOpen={setShowConfirm} 
            preview={preview ?? ""}
            list={list} 
            title={title ?? ""}
        />
        <Box sx={{ display: "flex", alignItems: "center"}}>
            <input 
                value={title}
                onChange={e => setTitle(e.target.value)}
                type="text" 
                className="input-title" 
                placeholder="Insira um Título"
            />
            <ToggleVisibilityButton isVisibledPublic={isVisibledPublic} changeToggle={setIsVisibledPublic}/>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center"}}>
            <textarea 
                value={preview}
                maxLength={200}

                onChange={e => setPreview(e.target.value)}
                className="input-preview" 
                placeholder="Insira uma prévio de até 200 letras"
            />
        </Box>
        <Box component="ul" sx={{ p: 0 }}>
            {
                list.map((block, index) =><AddBlock 
                    key={index} 
                    block={block} 
                    index={index} 
                    handleChangeContent={handleChangeContent}
                    handleRemove={handleRemove}
                    />)
            }

            <NewBlock handleNewBlock={handleNewBlock}/>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", marginBottom: "2em" }}>
            <Button disabled={
                list.length > 0 && 
                title && title?.length > 0 &&
                preview && preview?.length > 0 ? 
                false : true
                } variant="outlined" color="warning" onClick={handleClick}>
                Criar postagem
            </Button>
        </Box>
    </Container>
}

const AddBlock: React.FC<{
    block: Block, 
    index: number,
    handleChangeContent(content: string, i: number): void
    handleRemove(index: number): void
}> = ({ block, index, handleChangeContent, handleRemove }) => {
    if(block.type === BlockType.IMAGE)
        return <Box component="li" className="li-item" style={{ position: "relative"}}>
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                }}
            >
                <Tooltip title="Fechar">
                <IconButton color="warning" onClick={() => handleRemove(index)}>
                    <CloseIcon />
                </IconButton>
                </Tooltip>
            </Box>
            <img style={{ width: "100%"}} src={block.imageUrl}/>
        </Box>
    else
    return (
        <Box component="li" className="li-item">
            <TextEditor 
                index={index}
                block={block}
                onChangeContent={handleChangeContent}
                handleRemove={() => handleRemove(index)}
            />
        </Box>
    )
}

export default Blog;